import React from "react";

export default function ValidationError({ errors }) {
  return (
    <div className="sp-validation-error-pass">
      {errors.password && <span>{errors.password}</span>}
    </div>
  );
}
